/**
 * Test IDs for QA automation.
 */
export const testIds = {
  shipmentSummaryShippedGood: "shipment-summary-shipped-good",
  shipmentSummaryReceivedGood: "shipment-summary-received-good",
  shipmentSummaryEditLoadedQuantity: "shipment-summary-edit-loaded-quantity",
  shipmentSummaryEditDeliveredQuantity: "shipment-summary-edit-delivered-quantity",
  shipmentSummaryOpenTrip: "shipment-summary-open-trip",
  shipmentSummaryAssign: "shipment-summary-assign",
  shipmentSummaryCollapse: "shipment-summary-collapse",
  shipmentSummaryIntermediateStops: "shipment-summary-intermediate-stops",
  stopAddress: "stop-address",
  stopTimeWindow: "stop-time-window",
  stopCommodity: "stop-commodity",

  shipmentSummaryOpenDetails: "shipment-summary-open-details",
  shipmentSummaryEditTimelineLoadedQuantity: "shipment-summary-edit-timeline-loaded-quantity",
  shipmentSummaryEditTimelineDeliveredQuantity: "shipment-summary-edit-timeline-delivered-quantity",
} as const;
